const baseURL = "https://node-launchpad.mobiloitte.com";
const apiconfigs = {
  uploadKYC: `${baseURL}/api/v1/user/uploadKYC`,
  checkKYC: `${baseURL}/api/v1/user/checkKYC`,
  connectWallet: `${baseURL}/api/v1/user/connectWallet`,
  addImage: `${baseURL}/api/v1/user/addImage`,
};

export default apiconfigs;
